import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { Typography, InputLabel, InputAdornment, FormControl, OutlinedInput } from '@mui/material';
export const AdminFee = observer(() => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.selectedPropertyDetails().details.feeSetup.getPropertyFee({
      feeName: 'adminFee'
    })) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.value ? (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.selectedPropertyDetails().details.feeSetup.getPropertyFee({
      feeName: 'adminFee'
    })) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.value : null),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    amountTouched = _useState4[0],
    setAmountTouched = _useState4[1];
  const handleChange = e => {
    if (+e.target.value <= 99.99 && /^\d+([.,]\d{0,2})?$|^$/.test(+e.target.value)) {
      var _store$homeDashboardS3;
      setAmount(e.target.value);
      (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || _store$homeDashboardS3.selectedPropertyDetails().details.feeSetup.updateFee({
        feeName: 'adminFee',
        value: +e.target.value,
        feeUnitType: FEE_UNIT_TYPES.fixedAmount
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.amf')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('add_new_property_flow.amf_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('add_new_property_flow.confirmation_fee_text_plain'))), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: handleChange
    // error={amountTouched && amount === '0'}
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "resident-payment"
  }, t('add_new_property_flow.fee_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "resident-payment",
    label: t('add_new_property_flow.fee_value'),
    type: "number",
    value: amount,
    placeholder: "Not set",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    onBlur: () => {
      if (!amountTouched) setAmountTouched(true);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('add_new_property_flow.amf_caption'))));
});